import React from 'react';
import MobileDropdownToggle from './mobile-dropdown-toggle';
import AniLink from "gatsby-plugin-transition-link/AniLink";
import Patient from '../../../../../src/images/patient.svg';
import Provider from '../../../../../src/images/provider.svg';

interface Icon {
  altText: string;
  link: string;
  mediaItemUrl: string;
}

export interface Item {
  label: string;
  uri: string;
  menuIcons?: { icon: Icon };
  childItems: { nodes: Item[] };
}

interface MobileNavProps {
  isOpen: boolean;
  items: Item[];
  ctaColor: 'amethist' | 'sky' | 'fern' | 'amber';
  ctaText: string;
  ctaLink?: string;
  onClickHideMenu: () => void;
}

interface LoginLinkData {
  label: string;
  uri: string;
  altText: string;
  link: string;
}

const loginLinksData: LoginLinkData[] = [
  { label: "Patient", uri: "https://patient.pathapplication.com/", altText: "an icon of a patient", link: Patient },
  { label: "Provider", uri: "https://provider.pathapplication.com/signin", altText: "an icon of a therapist", link: Provider }
];

// Simplify the generation of link items from loginLinksData
const generateLinkItems = (linksData: LoginLinkData[]): Item[] => linksData.map(link => ({
  label: link.label,
  uri: link.uri,
  menuIcons: { icon: { altText: link.altText, link: link.link, mediaItemUrl: link.link } },
  childItems: { nodes: [] }
}));

const MobileNav: React.FC<MobileNavProps> = ({ isOpen, items, ctaColor, ctaText, ctaLink, onClickHideMenu }) => {
  const topLevelLinks: Item[] = items.filter(item => item.childItems?.nodes?.length === 0);
  const dropdownLinks: Item[] = items.filter(item => item.childItems && item.childItems.nodes.length > 0);
  const loginLinks: Item[] = [{ label: "Login", uri: "#", childItems: { nodes: generateLinkItems(loginLinksData) } }];

  return (
    <div className={`mobile-nav ${isOpen ? 'expanded' : 'closed'}`}>
        <div className={`mobile-nav-items ${isOpen ? 'open' : ''}`}>
          {dropdownLinks.map((item, index) => {
            return <MobileDropdownToggle key={index} label={item.label} items={item.childItems.nodes} onClickHideMenu={onClickHideMenu} ctaLink={ctaLink}/>
          })}
          {topLevelLinks.map((item, index) => {
            return <AniLink className="mobile-link" key={index} href={item.uri}>{item.label}</AniLink>
          })}
          {loginLinks.map((item, index) => {
            return <MobileDropdownToggle key={index} label={item.label} items={item.childItems?.nodes} />
          })}
          <AniLink className="mobile-link bottom" href={ctaLink}>
            <button className={`rula-button mobile-cta ${ctaColor}`} onClick={onClickHideMenu}>{ctaText}</button>
          </AniLink>
        </div>
    </div>
    )
  }

export default MobileNav